module.exports = __webpack_public_path__ + "static/media/icono2.8939c384.png";